import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LeadHeader } from '../components/leads/LeadHeader';
import { LeadContactBlock } from '../components/leads/LeadContactBlock';
import { LeadFieldsPanel } from '../components/leads/LeadFieldsPanel';
import { ScoreBreakdown } from '../components/leads/ScoreBreakdown';
import { LeadTimeline } from '../components/leads/LeadTimeline';
import { useDataStore } from '../context/DataStoreContext';
import { Lead, LeadState } from '../types/lead';
export function LeadDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const {
    leads,
    timeline,
    updateLead,
    addTimelineEvent
  } = useDataStore();
  const lead = leads.find(l => l.id === id);
  const leadTimeline = timeline.filter(t => t.leadId === id);
  if (!lead) {
    return <div className="p-8 text-center" data-id="element-982">
        <p className="text-growthly-muted mb-4" data-id="element-983">Lead no encontrado</p>
        <button onClick={() => navigate('/app/leads')} className="text-white bg-white/10 px-4 py-2 rounded-lg text-[13px]" data-id="element-984">
          Volver a Leads
        </button>
      </div>;
  }
  const handleStateChange = (newState: LeadState) => {
    updateLead(lead.id, {
      STATE: newState
    });
  };
  const handleFieldChange = (field: keyof Lead, value: any) => {
    updateLead(lead.id, {
      [field]: value
    });
  };
  const handleAddNote = (content: string) => {
    addTimelineEvent({
      leadId: lead.id,
      type: 'Note',
      content
    });
  };
  return <div className="p-4 md:p-8 max-w-[1240px] mx-auto pb-24 md:pb-8" data-id="element-985">
      <button onClick={() => navigate('/app/leads')} className="group flex items-center text-[13px] font-medium text-growthly-muted hover:text-white mb-5 transition-colors" data-id="element-986">
        <ArrowLeft className="w-4 h-4 mr-1.5 group-hover:-translate-x-0.5 transition-transform" data-id="element-987" />
        Volver a Leads
      </button>

      <LeadHeader lead={lead} onStateChange={handleStateChange} data-id="element-988" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5" data-id="element-989">
        {/* Left Column - Contact Info */}
        <div className="lg:col-span-3 space-y-5" data-id="element-990">
          <LeadContactBlock lead={lead} data-id="element-991" />
        </div>

        {/* Center Column - Fields & Score */}
        <div className="lg:col-span-6 space-y-5" data-id="element-992">
          <LeadFieldsPanel lead={lead} onChange={handleFieldChange} data-id="element-993" />
          <ScoreBreakdown lead={lead} data-id="element-994" />
        </div>

        {/* Right Column - Timeline */}
        <div className="lg:col-span-3" data-id="element-995">
          <LeadTimeline interactions={leadTimeline} leadId={lead.id} leadName={lead.NOMBRE_NEGOCIO} decisorEmail={(lead as any).DECISOR_EMAIL} onAddNote={handleAddNote} data-id="element-996" />
        </div>
      </div>
    </div>;
}